module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: " ml20 mr20"
  }, [_c('div', {
    staticClass: "white_bg yinying br10 pt50 pb50 mb20 p20 mt50"
  }, [_c('el-select', {
    staticClass: "mr45",
    attrs: {
      "filterable": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.optionValue),
      callback: function($$v) {
        _vm.optionValue = $$v
      },
      expression: "optionValue"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: " mb20 br10 mt20 p20",
    staticStyle: {
      "background-color": "#F2F6FF"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "font20 ",
    staticStyle: {
      "width": "100%",
      "border": "0",
      "background-color": "#F2F6FF",
      "resize": "none"
    },
    attrs: {
      "type": "textarea",
      "rows": 13,
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row flex-between mt25"
  }, [_c('div'), _c('el-button', {
    staticClass: "set-other-btn font24",
    staticStyle: {
      "width": "143px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.feedback($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebb86cfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fankui.vue
// module id = 1091
// module chunks = 1